export default "__VITE_ASSET__Iu3UYi0P__"